<script>
    /*
    	ReferralDetails.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components
    import ServiceReadFields from '../services/ServiceReadFields.svelte';

    // SMUI components
    import Button, { Label } from '@smui/button';


    export let store;           // masterService
    export let showDetails;     // closes the section

    onMount(() => {
    })

</script>

<style>
    .referral-details {
        min-height: 400px;
    }

    :global(.referral-details .mdc-button)  {
        min-width: 150px;
        margin: 0px;
        text-transform: none;
        color: var(--tcui-white) !important;
        background-color: var(--tcui-secondary) !important;
        border-radius: 18px;
        overflow: hidden;
    }

    :global(.referral-details .mdc-button:hover)  {
        background-color: var(--tcui-primary) !important;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="referral-details">
    <div class="flex-row">
        <Button on:click={() => showDetails(false)} variant="raised" >
            <Label>Close Details</Label>
        </Button>    
    </div>
    <div class="spacer-h-20"></div>
    <ServiceReadFields {store} />
    <div class="spacer-h-100"></div>
</div>
